import { useLoadMoreWovarProducts } from "@commercekit/remix";
import type {
  CursorPagination,
  CustomField,
  WovarProduct,
} from "@commercekit/api";

export const useLoadMoreProducts = (
  products: WovarProduct[],
  categoryId: string,
  filters: CustomField[],
  pagination: CursorPagination | undefined,
  // WOV-2195: false in the numbered-pagination variant.
  enabled = true
) => {
  const { loadRef, loadMore, hasNextPage, loadMoreLoading, ...rest } =
    useLoadMoreWovarProducts(products, categoryId, filters, pagination, enabled);

  return { loadMoreLoading, loadRef, loadMore, hasNextPage, ...rest };
};
